var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell",class:_vm.isAlive.isAlive ? 'alive' : 'dead',on:{"mousedown":function($event){return _vm.reborn(true)},"mouseover":function($event){return _vm.reborn(_vm.isMouseDown)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }